import React, { createContext, FC, useState } from 'react';
import { ContractorOrdersWidget, CustomerOrdersWidget } from './components';
import { UserOrdersWidgetStore } from './store/UserOrders.store';
import { IUserOrdersWidgetProps, TUserTypes } from './interfaces';

const UserTypeComponentMapping: Record<TUserTypes, FC<IUserOrdersWidgetProps>> = {
  customer: CustomerOrdersWidget,
  contractor: ContractorOrdersWidget,
  employee: CustomerOrdersWidget,
  partner: CustomerOrdersWidget,
};

export const UserOrdersStoreContext = createContext<UserOrdersWidgetStore | null>(null);

export const UserOrdersWidget: FC<IUserOrdersWidgetProps> = (props) => {
  const [store] = useState(() => new UserOrdersWidgetStore(props.id, props.provider));

  const Component = UserTypeComponentMapping[props.userType];

  return (
    <UserOrdersStoreContext.Provider value={store}>
      <Component {...props} />
    </UserOrdersStoreContext.Provider>
  );
};
